var ubian = ubian || {};
ubian.purse = {};

ubian.purse.charge = function (snr, companyID, value, currencyID, dialog) {
  $.post(
    ubian.routes["purse_charge"],
    { snr: snr, companyID: companyID, value: value, currency: currencyID },
    function (res) {
      if (res.status === "ok") {
        ubian.cart.unhideSummaryBar();
        $(dialog).modal("hide");
        window.location = ubian.routes["basket_view"];
      } else {
        if (res.errorCode == 140) {
          ubian.utils.alert(ubian.translate(res.error));
        } else {
          $(".js-purse-error").text(ubian.translate(res.error));
        }
        $(".modal-body").scrollTop(9999);
      }
    }
  );
};

ubian.purse.getValues = function (companyID, cb) {
  var parent = "#card-credit-" + companyID;
  $(parent + " .loader-wrapper").removeClass("disabled");
  $(parent + " #card-credit-show").addClass("card-hidden");
  $.post(ubian.routes["purse_get_values"], { companyID: companyID })
    .done(function (res) {
      cb(res, companyID);
    })
    .fail(function (xhr, status, error) {
      alert(parent + " .loader-wrapper");
      $(parent + " .loader-wrapper").addClass("disabled");
      $(parent + " #card-credit-show").removeClass("card-hidden");
      $(parent + " #card-credit-show").css("display", "block");
    });
};

ubian.purse.chargeDialog = function (snr, companyID, companyName, isEmulated) {
  ubian.purse.getValues(companyID, showChargeDialog);
};

/**
 * Vykreslenie dlazdice po vyrenderovani back-endom na clienta.
 * @param dialogHTML - vyrenderovana dlazdica (html)
 * @param companyId
 */
function showChargeDialog(dialogHTML, companyId) {
  var parent = "#card-credit-" + companyId;
  $(parent + " .loader-wrapper").addClass("disabled");
  $(parent + " #card-credit-show").css("display", "none");

  $(parent + " #card-credit-purchase").html(dialogHTML);
  $(".js-purse-credit-back").click(function () { purseCreditAbort(companyId) });
  $(parent + " #card-credit-purchase").removeClass("card-hidden");
  $(parent + ' #card-credit-purchase .value').click(function () {
    $(parent + ' #card-credit-purchase .value').removeClass("active");
    $(this).addClass("active");
    if ($(this).hasClass("js-custom-price")) {
      $(parent + " .custom-price-wrapper").removeClass("hidden");
      $(parent + " .js-submit-purse-charge-2").removeClass("disabled");
      $(parent + " #card-credit-purchase .js-submit-purse-charge-2").data("charge", $(parent + " .custom-price-value").val());
    }
    else {
      $(parent + " .custom-price-wrapper").addClass("hidden");
      $(parent + " #card-credit-purchase .js-submit-purse-charge-2").data("charge", $(this).data("value"));
      $(parent + " .js-submit-purse-charge-2").removeClass("disabled");
    }
  });
  $(parent + " #card-credit-purchase .js-submit-purse-charge-2").click(function () {
    var price = $(this).data("charge");
    if (!isNaN(price) && parseInt(Number(price)) == price && !isNaN(parseInt(price, 10))) {
      if (!(price >= 5 && price <= 150)) {
        ubian.utils.alert(ubian.translate('JS.Purse.ChargeAmount.Error'), null, null);
        return;
      }
    }
    else {
      ubian.utils.alert(ubian.translate('JS.Purse.ChargeAmount.NotNumber'), null, null);
      return;
    }
    if (price > 0) {
      $(parent + " #card-credit-purchase").addClass("card-hidden");
      $(parent + " .loader-wrapper").removeClass("disabled");
      $.post(
        ubian.routes["purse_charge"],
        { snr: $(parent + " .js-charge-purse").data("snr"), companyID: companyId, value: $(this).data("charge"), currency: $(this).data("currencyId") },
        function (res) {
          if (res.status === "ok") {
            ubian.cart.unhideSummaryBar();
            window.location = ubian.routes["basket_view"];
          } else {
            $(parent + " .loader-wrapper").addClass("disabled");
            $(parent + " #card-credit-purchase").removeClass("card-hidden");
            ubian.utils.alert(ubian.translate(res.error));
            $(".modal-body").scrollTop(9999);
          }
        }
      );
    } else {
      ubian.utils.alert("Zvoľte sumu kreditu.");
      $(parent + " .js-submit-purse-charge-2").addClass("disabled");
    }
  })
  $(parent + " .custom-price-value").keyup(function () {
    var customPrice = $(this).val();
    $(parent + " #card-credit-purchase .js-submit-purse-charge-2").data("charge", customPrice);
  });
  $(parent + " .custom-price-value").change(function () {
    var customPrice = $(this).val();
    $(parent + " #card-credit-purchase .js-submit-purse-charge-2").data("charge", customPrice);
  });
  // scroll to viewport of EP
  $('html, body').animate({
    scrollTop: $("#card-credit-purchase").offset().top
  }, 500);

  $(window).on("unload", function () {
    $(parent + " .loader-wrapper").addClass("disabled");
    $(parent + " #card-credit-purchase").removeClass("card-hidden");
  });
}

/**
 * Zrusenie okna na dobitie kreditu. Vrati zakaznika spat na povodnu dlazdicu
 * @param companyId
 */
function purseCreditAbort(companyId) {
  var parent = "#card-credit-" + companyId;
  $(parent + " .loader-wrapper").removeClass("disabled");
  $(parent + " #card-credit-purchase").addClass("card-hidden");
  setTimeout(function () {
    $(parent + " #card-credit-purchase").empty();
    $(parent + " #card-credit-show").css("display", "block");
    $(parent + " .loader-wrapper").addClass("disabled");
    setTimeout(function () {
      $(parent + " #card-credit-show").removeClass("card-hidden");
    }, 100);
  }, 300);

}

ubian.purse.chargeNotAllowedDialog = function (isExpiredCard) {
  ubian.utils.alert(
    ubian.translate(
      isExpiredCard ? "JS.Purse.CardExpired" : "JS.Purse.ChargeNotSupported"
    )
  );
};

ubian.purse.chargeIFC = function (snr, cid) {
  window.location =
    ubian.routes["purse_charge_ifc"] + "?snr=" + snr + "&cid=" + cid;
};

$(function () {
  $(".js-charge-purse").click(function () {
    if (parseInt($(this).data("ifc")) === 0) {
      ubian.purse.chargeDialog(
        $(this).data("snr"),
        $(this).data("cid"),
        $(this).data("company-name"),
        $(this).data("emulated")
      );
    } else {
      ubian.purse.chargeIFC($(this).data("snr"), $(this).data("cid"));
    }
  });
  $(".js-charge-purse-not-allowed").click(function () {
    ubian.purse.chargeNotAllowedDialog($(this).data("card-expired"));
  });
  if (typeof ubian.chargePurse !== "undefined") {
    $(".js-charge-purse[data-cid=" + ubian.chargePurse + "]").click();
  }

});
